var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let PageWithPanel = class PageWithPanel extends LitElement {
    constructor() {
        super(...arguments);
        this.leftLabel = null;
        this.rightLabel = null;
        this.leftOpen = false;
        this.rightOpen = false;
        this.leftWidth = 300;
        this.rightWidth = 300;
    }
    render() {
        return html `
      ${this.leftOpen
            ? html `
            <div class="panel left-panel" style="width:${this.leftWidth}px">
              <slot name="left"></slot>
              <div
                class="resizer resizer-left"
                @mousedown=${(e) => this.initResize(e, 'left')}
              ></div>
            </div>
          `
            : ''}

      <div class="page-container">
        ${this.leftLabel
            ? this.leftOpen
                ? html `<simple-button
                class="button-left"
                variant="danger"
                label="${msg('Close', { id: 'panel.close', desc: 'Close panel button' })}"
                @button-click=${this.toggleLeft}
              ></simple-button>`
                : html `<simple-button
                class="button-left"
                variant="secondary"
                .label=${this.leftLabel}
                @button-click=${this.toggleLeft}
              ></simple-button>`
            : ''}
        ${this.rightLabel
            ? this.rightOpen
                ? html `<simple-button
                class="button-right"
                variant="danger"
                label="${msg('Close', { id: 'panel.close', desc: 'Close panel button' })}"
                @button-click=${this.toggleRight}
              ></simple-button>`
                : html `<simple-button
                class="button-right"
                variant="secondary"
                .label=${this.rightLabel}
                @button-click=${this.toggleRight}
              ></simple-button>`
            : ''}
        <div class="content">
          <slot name="page"></slot>
        </div>
      </div>

      ${this.rightOpen
            ? html `
            <div class="panel right-panel" style="width:${this.rightWidth}px">
              <slot name="right"></slot>
              <div
                class="resizer resizer-right"
                @mousedown=${(e) => this.initResize(e, 'right')}
              ></div>
            </div>
          `
            : ''}
    `;
    }
    toggleLeft() {
        if (!this.leftLabel)
            return;
        const panel = this.shadowRoot.querySelector('.left-panel');
        panel?.classList.add('anim');
        if (this.rightOpen)
            this.rightOpen = false;
        this.leftOpen = !this.leftOpen;
    }
    toggleRight() {
        if (!this.rightLabel)
            return;
        const panel = this.shadowRoot.querySelector('.right-panel');
        panel?.classList.add('anim');
        if (this.leftOpen)
            this.leftOpen = false;
        this.rightOpen = !this.rightOpen;
    }
    initResize(e, side) {
        e.preventDefault();
        const startX = e.clientX;
        const panel = this.shadowRoot.querySelector(side === 'left' ? '.left-panel' : '.right-panel');
        const startWidth = panel.offsetWidth;
        let rafId;
        const onMouseMove = (e) => {
            const dx = e.clientX - startX;
            let newWidth = side === 'left' ? startWidth + dx : startWidth - dx;
            newWidth = Math.min(Math.max(50, newWidth), window.innerWidth / 3);
            if (rafId)
                cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                panel.style.width = `${newWidth}px`;
            });
        };
        const onMouseUp = () => {
            const finalWidth = parseInt(panel.style.width);
            if (side === 'left')
                this.leftWidth = finalWidth;
            else
                this.rightWidth = finalWidth;
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
    }
};
PageWithPanel.styles = css `
    :host {
      display: flex;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      font-family: inherit;
      min-height: 400px; /* ensure some height */
    }

    .page-container {
        flex: 1 1 auto; /* stretch */
        min-height: 400px; /* ensure it never collapses */
        position: relative;
        overflow: hidden;
    }

    .panel {
      overflow: hidden;
      min-width: 50px;
      max-width: 33%;
      display: flex;
      flex-direction: column;
      position: relative;
      padding: 1rem;
      box-sizing: border-box;
      height: 100%;
    }

    /* Transition uniquement lors du toggle */
    .panel.anim {
      transition: width 0.3s;
    }

    .left-panel {
      border-right: 1px solid #ccc;
    }

    .right-panel {
      border-left: 1px solid #ccc;
    }

    .content {
      width: 100%;
      height: 100%;
      background: #fff;
      box-sizing: border-box;
    }

    /* Boutons flottants dans les coins */
    .button-left,
    .button-right {
      position: absolute;
      top: 0.5rem;
      z-index: 100;
    }
    .button-left {
      left: 0.5rem;
    }
    .button-right {
      right: 0.5rem;
    }

    .resizer {
      width: 5px;
      cursor: ew-resize;
      background: rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 10;
    }

    .resizer-left {
      right: 0;
    }

    .resizer-right {
      left: 0;
    }
  `;
__decorate([
    property({ type: String })
], PageWithPanel.prototype, "leftLabel", void 0);
__decorate([
    property({ type: String })
], PageWithPanel.prototype, "rightLabel", void 0);
__decorate([
    property({ type: Boolean })
], PageWithPanel.prototype, "leftOpen", void 0);
__decorate([
    property({ type: Boolean })
], PageWithPanel.prototype, "rightOpen", void 0);
__decorate([
    property({ type: Number })
], PageWithPanel.prototype, "leftWidth", void 0);
__decorate([
    property({ type: Number })
], PageWithPanel.prototype, "rightWidth", void 0);
PageWithPanel = __decorate([
    localized(),
    customElement('page-with-panel')
], PageWithPanel);
export { PageWithPanel };
//# sourceMappingURL=PageWithPanel.js.map